import ProductJSON from '../pages/product-page/product-json';

const ImageList = function () {
    const sections = document.querySelectorAll('.section > .image-list');
    sections.forEach(section => {

        const mainDesktop = section.querySelector( '.image-list__images' );
        const titlesDesktop = section.querySelector( '.image-list__titles' );
    
        const initHoverEffect = () => {
            let slidesArray = [];
            let images = mainDesktop.querySelectorAll('.slide');
            images.forEach(image => {
                let imageElement = image.querySelector('img');
                slidesArray.push(imageElement);
            });
            
            let titles = titlesDesktop.querySelectorAll('.slide');
            titles.forEach(title => {
                let index = title.dataset.slide;
                title.addEventListener('mouseenter', (event) => {
                    images.forEach(image => {
                        image.classList.remove('active');
                    })
                    images[index].classList.add('active');

                    titles.forEach(item => {
                        item.classList.remove('active');
                    });
                    title.classList.add('active');
                });
            });
        }
    
        if ( section.classList.contains('is-dynamic')) {
            const hasDynamicCollection = section.dataset.dynamicCollection != null ? true : false;
            let url = '';
            if( hasDynamicCollection ){
                url = window.Shopify.routes.root + 'collections/'+ section.dataset.dynamicCollection+'/?view=image-list-ajax'
            }
            if( !hasDynamicCollection){
                let { currentVariant, productOptions  } = ProductJSON();
                if( productOptions ){
                    neckFinishPosition = productOptions.findIndex( option => option.name == 'Neck Finish');
                    lengthPosition = productOptions.findIndex( option => option.name == 'Length');
                }
                let neckFinishes = '&filter.v.option.neck+finish=' + productOptions[ neckFinishPosition ].values.join('&filter.v.option.neck+finish=')
                let lengths = '&filter.v.m.variant.length=' + productOptions[ lengthPosition ].values.join('&filter.v.m.variant.length=')
                url = window.Shopify.routes.root + 'collections/all/?view=image-list-ajax'
                url += '&filter.p.product_type=Item'
                url += neckFinishes
                url += lengths
                url += '&filter.p.tag=Featured'
            }

            
            fetch(url)
            .then(response => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;

                const numResults = html.querySelector('[data-num-results]').dataset.numResults
                if (numResults > 0) {
                    const images = section.querySelector('[data-images]')
                    const titles = section.querySelector('[data-titles]')
        
                    const newImages = html.querySelector('[data-images]')
                    const newTitles = html.querySelector('[data-titles]')
        
                    images.innerHTML = newImages.innerHTML;
                    titles.innerHTML = newTitles.innerHTML;
        
                    initHoverEffect();
                } else {
                    section.classList.add('d-none')
                }
    
            })
            .catch(err => {
                console.error(err);
            });
        } else {
            initHoverEffect();
        }
    })
  
}

export default ImageList;